import { IMenuItem } from '../../models/menu.model';
import { setupMenu } from './setup.menu';

const _superAdminMenu: IMenuItem[] = [
  {
    label: 'Account Reconciliations',
    path: 'account-recon',
    id: 'MID_SADMIN_RECON',
    icon: 'fa fa-calculator',
  },
  {
    label: 'Candidates',
    path: 'candidates',
    id: 'MID_SADMIN_CANDIDATES',
    icon: 'fa fa-user-plus',
  },
  {
    label: 'Agents',
    path: 'agents',
    id: 'MID_SADMIN_AGENTS',
    icon: 'fa fa-id-badge',
  },
  {
    label: 'Manage Agents',
    path: 'manage-agents',
    id: 'MID_SADMIN_MANAGE_AGENTS',
    icon: 'fa fa-users-cog',
  },
  {
    label: 'User Menus',
    path: 'user-menu',
    id: 'MID_SADMIN_USER_MENUS',
    icon: 'fa fa-list-check',
  },
  {
    label: 'Agent Staging',
    path: 'agent-staging',
    id: 'MID_SADMIN_STAGING',
    icon: 'fa fa-hourglass-half',
  },
  {
    label: 'Recalculate Agent License Expiry',
    path: 'patch-license',
    id: 'MID_SADMIN_PATCH_LICENSE',
    icon: 'fa fa-history',
  },
  {
    label: 'Batch Operations',
    path: 'batch',
    id: 'MID_SADMIN_BATCH',
    icon: 'fa fa-tasks',
  },
  {
    label: `Batch Candidate Update`,
    path: 'batch-candidate-update',
    id: 'MID_SADMIN_BATCH_CANDIDATE',
    icon: 'fa fa-upload',
  },
  {
    label: `Batch Company Payment Update`,
    path: 'batch-company-payment-update',
    id: 'MID_SADMIN_BATCH_PAYMENT',
    icon: 'fa fa-credit-card',
  },
  {
    label: `Agent Staging Migration`,
    path: 'agent-staging-migration',
    id: 'MID_SADMIN_STAGING_MIGRATION',
    icon: 'fa fa-exchange',
  },
];

export const superAdminMenu: IMenuItem[] = [
  setupMenu,
  ..._superAdminMenu.map((x) => ({ ...x, path: '/super/' + x.path })),
];
